import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class TotalUnitHiredReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            url:'/api/v1/portal/portal-admin/total-unit-hired-report/',
            totalJobs:[],
            selectedStartDate:moment().toDate(),
            selectedEndDate:moment().toDate(),
            downloadReportName:'Total Unit Hired Report',
            isDownloading:false,
            totalJobs:0
        };
        this.handleselectedStartDateChange = this.handleselectedStartDateChange.bind(this);
        this.handleselectedEndDateChange = this.handleselectedEndDateChange.bind(this);
    }
    handleselectedStartDateChange(date) {
        this.setState({selectedStartDate: date})
    }
    handleselectedEndDateChange(date) {
        this.setState({selectedEndDate: date})
    }
    handleTotalJobsSetToInvoiceReport(e) {
        this.setState({isLoading: true});
        let url = this.state.url+moment(this.state.selectedStartDate).format("YYYY-MM-DD")+'/'+moment(this.state.selectedEndDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              this.setState({
                totalJobs: response.jobs,
                isLoading: false
              })
            });
          }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }

    downloadableCsvDataTotalJobsRaisedByUser(filename, text){
        let filenamed = filename+" FROM "+moment(this.state.selectedStartDate).format("YYYY-MM-DD")+" TO "+moment(this.state.selectedEndDate).format("YYYY-MM-DD")+".csv";
        let textdata = "TYPE OF UNIT,UNIT TERM,TOTAL JOBS,TOTAL QTY PER UNIT TYPE\n"+text;
        let element = document.createElement('a');
        element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(textdata)
        );
        element.setAttribute('download',filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    render() {
        let totalJobs = [];
        let totalUnitHired = 0;
        let downloadableCsvDataInvoiced = "";
        if(this.state.totalJobs.length > 0){
            this.state.totalJobs.map((currentJob, index) => {
                // let joburl = "/jobs/view/"+currentJob.id;
                totalJobs.push(
                        <tr key={index}>
                            <td className="job-ref-font16">{currentJob.unit_type.replace(/\_/g, ' ')}</td>
                            <td>{currentJob.unit_term}</td>
                            <td>{currentJob.totalJobs}</td>    
                            <td>{currentJob.unitQty}</td>        
                        </tr>
                );
                totalUnitHired = (totalUnitHired) + parseInt(currentJob.unitQty);
                downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                        (currentJob.unit_type.replace(/\_/g, ' '))+','+
                                        (currentJob.unit_term)+','+
                                        (currentJob.totalJobs)+','+
                                        (currentJob.unitQty)+"\n";
            });
          
        }else{
            totalJobs.push(
               <tr key='no-records'><td colSpan="10" className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Total Unit Hired Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-1">
                        From Date:
                    </div>
                    <div className="col-md-1">
                        To Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-1">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleselectedStartDateChange} selected={this.state.selectedStartDate}/>
                    </div>
                    <div className="col-md-1">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleselectedEndDateChange} selected={this.state.selectedEndDate}/>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsSetToInvoiceReport(e)}>
                                <i className="fa fa-download"></i> Generate Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvDataTotalJobsRaisedByUser(this.state.downloadReportName, downloadableCsvDataInvoiced)}}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <h4 className="alert alert-info">Total Units hired from {moment(this.state.selectedStartDate).format("DD/MM/YYYY")} to {moment(this.state.selectedEndDate).format("DD/MM/YYYY")} are : <b>{totalUnitHired}</b></h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                    <tr>
                                        <th>Type of Unit</th>
                                        <th>Unit Term</th>
                                        <th>Total Jobs</th>
                                        <th>Total Qty Per UNIT Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="4"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totalJobs}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-total_unit_hired_report')) {
    ReactDOM.render(
        <TotalUnitHiredReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-total_unit_hired_report')
    );
}
